// extracted by mini-css-extract-plugin
export default {"icon":"LockIcon_icon__8GRmt"};